/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoPilotPromotionLogListPilotPromotionLogData model module.
 * @module model/LogControllerDtoPilotPromotionLogListPilotPromotionLogData
 * @version 1.0
 */
class LogControllerDtoPilotPromotionLogListPilotPromotionLogData {
    /**
     * Constructs a new <code>LogControllerDtoPilotPromotionLogListPilotPromotionLogData</code>.
     * @alias module:model/LogControllerDtoPilotPromotionLogListPilotPromotionLogData
     */
    constructor() { 
        
        LogControllerDtoPilotPromotionLogListPilotPromotionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoPilotPromotionLogListPilotPromotionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoPilotPromotionLogListPilotPromotionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoPilotPromotionLogListPilotPromotionLogData} The populated <code>LogControllerDtoPilotPromotionLogListPilotPromotionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoPilotPromotionLogListPilotPromotionLogData();

            if (data.hasOwnProperty('promotionNo')) {
                obj['promotionNo'] = ApiClient.convertToType(data['promotionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftRarity')) {
                obj['nftRarity'] = ApiClient.convertToType(data['nftRarity'], 'Number');
            }
            if (data.hasOwnProperty('skillNumber')) {
                obj['skillNumber'] = ApiClient.convertToType(data['skillNumber'], 'Number');
            }
            if (data.hasOwnProperty('skillType')) {
                obj['skillType'] = ApiClient.convertToType(data['skillType'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount')) {
                obj['skillAmount'] = ApiClient.convertToType(data['skillAmount'], 'Number');
            }
            if (data.hasOwnProperty('materialNftUid1')) {
                obj['materialNftUid1'] = ApiClient.convertToType(data['materialNftUid1'], 'Number');
            }
            if (data.hasOwnProperty('materialNftUid2')) {
                obj['materialNftUid2'] = ApiClient.convertToType(data['materialNftUid2'], 'Number');
            }
            if (data.hasOwnProperty('materialNftUid3')) {
                obj['materialNftUid3'] = ApiClient.convertToType(data['materialNftUid3'], 'Number');
            }
            if (data.hasOwnProperty('materialNftUid4')) {
                obj['materialNftUid4'] = ApiClient.convertToType(data['materialNftUid4'], 'Number');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'String');
            }
            if (data.hasOwnProperty('itemTransactionNo')) {
                obj['itemTransactionNo'] = ApiClient.convertToType(data['itemTransactionNo'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoPilotPromotionLogListPilotPromotionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoPilotPromotionLogListPilotPromotionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['walletTransactionNo'] && !(typeof data['walletTransactionNo'] === 'string' || data['walletTransactionNo'] instanceof String)) {
            throw new Error("Expected the field `walletTransactionNo` to be a primitive type in the JSON string but got " + data['walletTransactionNo']);
        }
        // ensure the json data is a string
        if (data['itemTransactionNo'] && !(typeof data['itemTransactionNo'] === 'string' || data['itemTransactionNo'] instanceof String)) {
            throw new Error("Expected the field `itemTransactionNo` to be a primitive type in the JSON string but got " + data['itemTransactionNo']);
        }

        return true;
    }


}



/**
 * @member {Number} promotionNo
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['promotionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} nftRarity
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['nftRarity'] = undefined;

/**
 * @member {Number} skillNumber
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['skillNumber'] = undefined;

/**
 * @member {Number} skillType
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['skillType'] = undefined;

/**
 * @member {Number} skillAmount
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['skillAmount'] = undefined;

/**
 * @member {Number} materialNftUid1
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['materialNftUid1'] = undefined;

/**
 * @member {Number} materialNftUid2
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['materialNftUid2'] = undefined;

/**
 * @member {Number} materialNftUid3
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['materialNftUid3'] = undefined;

/**
 * @member {Number} materialNftUid4
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['materialNftUid4'] = undefined;

/**
 * @member {String} walletTransactionNo
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['walletTransactionNo'] = undefined;

/**
 * @member {String} itemTransactionNo
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['itemTransactionNo'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoPilotPromotionLogListPilotPromotionLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoPilotPromotionLogListPilotPromotionLogData;

